const API_URL = 'https://ls-mamta.replit.app/api';

export const sendPasswordResetEmail = async (email) => {
    try {
        const response = await fetch(`${API_URL}/request-password-reset`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({ email }),
        });

        const data = await response.json();

        if (!response.ok) {
            throw new Error(data.message || 'Failed to send password reset email');
        }

        return {
            success: true,
            message: 'Password reset instructions have been sent to your email'
        };
    } catch (error) {
        return {
            success: false,
            message: error.message || 'An error occurred while sending the password reset email'
        };
    }
}; 